{
	"creatingAiStyle": "Creating your AI Style...",
	"savingAiStyle": "Saving Your AI Style",
	"updatingAiStyle": "Updating your AI Style...",
	"uploadingReferences": "Uploading your style references. This may take a few moments."
}
